import React from "react";
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import CHART_COLORS from "./chartColors";

const HorizontalBarChart = ({ question, results }) => {
	// Create data for all available response options, even if they have no results
	const chartData = [];

	if (question.responses) {
		question.responses.forEach((questionResponse, index) => {
			const resultResponse = results.responses.find(r => r.responseKey === questionResponse.key);

			chartData.push({
				name: questionResponse.title,
				percentage: resultResponse ? resultResponse.percentage : 0,
				count: resultResponse ? resultResponse.count : 0,
				fill: CHART_COLORS[index % CHART_COLORS.length],
			});
		});
	}

	// Sort by percentage descending
	chartData.sort((a, b) => b.percentage - a.percentage);

	return (
		<div className="chart-container horizontal-bar-chart">
			<div className="chart-header">
				<h4>{question.title}</h4>
				{question.subtitle && <p className="chart-subtitle">{question.subtitle}</p>}
			</div>

			<ResponsiveContainer width="100%" height={Math.max(300, chartData.length * 60)}>
				<BarChart layout="vertical" data={chartData} margin={{ right: 20 }}>
					<CartesianGrid strokeDasharray="3 3" horizontal={false} />
					<XAxis type="number" domain={[0, 100]} tickFormatter={value => `${value}%`} />
					<YAxis type="category" dataKey="name" width={100} tick={{ fontSize: 14 }} />
					<Tooltip
						cursor={{ fill: "transparent" }}
						formatter={(value, props) => {
							const count =
								props && props.payload
									? props.payload.count
									: chartData.find(d => d.percentage === value)?.count || 0;
							return [`${value}% (${count} ${count === 1 ? "vote" : "votes"})`, "Percentage"];
						}}
						labelFormatter={label => `${label}`}
					/>
					<Bar dataKey="percentage" radius={[0, 4, 4, 0]}>
						{chartData.map((entry, index) => (
							<Cell key={`cell-${index}`} fill={entry.fill} />
						))}
					</Bar>
				</BarChart>
			</ResponsiveContainer>
			<div className="chart-footer">
				Total Votes: {results.totalVotes}{" "}
				{question.responseType === "checkbox" && "• Multiple selections allowed"}
			</div>
		</div>
	);
};

export default HorizontalBarChart;
